// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "styles/" + chunkId + "-" + {"190":"31d6cfe0d16ae931b73c","242":"87d647d12d38aaf8b6a5"}[chunkId] + ".css";
};